import Vue from 'vue';
import Axios from 'axios';
import Errors from '../classes/Errors';
import store from '../store';

Vue.component('register-form', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            success: false,
            submitting: false,
            client: store.client
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        onRegisterSubmit(event) {
            this.submitting = true;
            this.errors.clear();

            Axios
                .post(event.currentTarget.action, this.client)
                .then(response => {
                    this.submitting = false;
                    this.handleRegisterSuccess();
                })
                .catch(error => {
                    this.handleRegisterErrors(error.response.data);
                });
        },

        handleRegisterSuccess() {
            this.$root.startSurvey();
        },

        handleRegisterErrors(data) {
            this.errors.record(data.errors);
        }
    }
});
